// extracted by mini-css-extract-plugin
module.exports = {"ManageTemplate":"ManageTemplate_ManageTemplate__2G5u6"};